import Lista from './Lista';

export const EmprestimoEpiLista = Lista;
